import { config } from "config/config";
import { IRecurlyCoupon, IRecurlyCouponRedemption } from "store/entities/recurly";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any;

export interface IRecurlyToken {
  id: string;
}

class RecurlyService {
  static configure(): void {
    const { recurly } = window;
    const preparedParams = {
      publicKey: config.recurlyPublicKey,
    };
    recurly.configure(preparedParams);
  }

  static checkCoupon(
    couponName: string,
    couponRedemptions: IRecurlyCouponRedemption[],
    plan: string,
    agents: number
  ): Promise<IRecurlyCoupon | null> {
    const { recurly } = window;

    if (!recurly.configured) {
      this.configure();
    }

    const pricing = recurly.Pricing();

    return new Promise<IRecurlyCoupon | null>((resolve, reject) => {
      pricing
        .plan(plan, { quantity: agents })
        .coupon(couponName) // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          reject(error);
        }) // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((couponData: any) => {
          if (couponData) {
            const { code, discount, duration, applies_to_all_plans, applies_for_months, plans } = couponData;
            resolve({
              code,
              discount: {
                type: discount.type,
                value: discount.rate ? discount.rate * 100 : discount.amount.USD,
                suffixValue: discount.rate ? `${discount.rate * 100}%` : `${discount.amount.USD}$`,
              },
              duration,
              redeemed: false,
              appliesToAllPlans: applies_to_all_plans,
              appliesForMonths: applies_for_months,
              plans,
              redemptions: couponRedemptions,
            });
          } else {
            resolve(null);
          }
        });
    });
  }
}

export default RecurlyService;
